var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningAsset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.302 1.53l-.014.026L.48 15.875l-.006.011-.15.274-.274.503a.313.313 0 00.275.462h17.35a.312.312 0 00.274-.462l-.274-.503-.149-.274-.006-.011-7.808-14.32-.014-.025-.191-.351-.233-.426a.313.313 0 00-.548 0l-.233.426-.191.351zM9 2.861L1.904 15.875h14.192L9 2.861zm.625 4.889v4.375h-1.25V7.75h1.25zM9 14.625a.625.625 0 100-1.25.625.625 0 000 1.25z"
  })));
}

export default __webpack_public_path__ + "a22ea8e1a12b4233d0917a91894e7c3c.svg";
export { SvgWarningAsset as ReactComponent };